import React, { useEffect, useState } from "react";
import Polls from "../../../components/Polls/Polls";
import Contests from "../../../components/Contests/Contests";
import Users from "../../../components/Users/Users";
import Events from "../../../components/Events/Events";
import Notifications from "../../../components/Notifications/Notifications";
import { getPollsList } from "../../../store/slices/pollSlice";
import { useDispatch } from "react-redux";
import { getContestsList } from "../../../store/slices/contestSlice";
import { getOnlineUsersTillNow } from "../../../store/slices/chatSlice";

const NestedComponent = () => {
    const dispatch = useDispatch();


    const [activeTab, setActiveTab] = useState("polls");

    useEffect(() => {
        dispatch(getPollsList({ page: 1, limit: 5 }));
        dispatch(getContestsList({ page: 1, limit: 5 }));
        dispatch(getOnlineUsersTillNow({ page: 1, limit: 100 }));

    }, [dispatch]);


    const renderComponent = () => {
        switch (activeTab) {
            case "polls":
                return <Polls />;
            case "contests":
                return <Contests />;
            case "users":
                return <Users />;
            case "events":
                return <Events />;
            case "notifications":
                return <Notifications />;
            default:
                return <Polls />;
        }
    };

    return (
        <div className="d-flex flex-column h-100 overflow-hidden nestedComponentContainer">
            {/* Navigation Tabs */}
            <div className="navigatationBar d-flex">
                {[
                    { key: "polls", label: "Polls" },
                    { key: "contests", label: "Contests" },
                    { key: "users", label: "Current Listeners" },
                    { key: "events", label: "Events" },
                    { key: "notifications", label: "Notifications" },
                ].map(({ key, label }) => (
                        <a
                            key={key}
                            href="#"
                            className={activeTab === key ? "active-anchor" : ""}
                            onClick={(e) => {
                                e.preventDefault();
                                setActiveTab(key);
                            }}
                        >
                           <div>{label}</div>
                        </a>
                ))}
            </div>

            {renderComponent()}
        </div>
    );
};

export default NestedComponent;
